import axios, { AxiosPromise } from 'axios'

interface ImprimirInativoInput {
  coUnicoAtendProf: string
}

export class RetificacaoAtendimento {
  imprimirAtendimentoInativo(imprimirInativoInput: ImprimirInativoInput): AxiosPromise<Blob> {
    return axios.post('/api/retificacaoAtendimento/imprimirInativo', imprimirInativoInput, {
      responseType: 'blob',
    })
  }
}
